import { IBaseModel } from '../system/BaseModel';
import { IApplianceType } from './ApplianceType';
import { IApplianceManufacturer } from './ApplianceManufacturer';
import {
  IPlanetDeviceSerialSettings,
  PlanetDeviceProtocol,
} from '../PlanetDevice/PlanetDevice';

export interface IApplianceModel extends IBaseModel {
  disabled: boolean;
  name: string;
  hardwareManufacturerId: string;
  hardwareManufacturer: IApplianceManufacturer;
  hardwareTypeId: string;
  classification: ApplianceModelClassification;
  hardwareType: IApplianceType;
  partial: boolean;
  serialSettings: IPlanetDeviceSerialSettings;
  address: number;
  restore?: boolean;
  endianness: ApplianceModelEndianness;
  protocol: PlanetDeviceProtocol;
  magicNumbers?: number[];
}

export enum ApplianceModelClassification {
  None,
  Verified,
  Pilot,
  Preview,
  Tentative,
  Core,
}

export const ApplianceModelClassificationColours = [
  undefined,
  '00C64A',
  '007BFF',
  'C6AD00',
  'C64200',
  'B760F9',
];

export enum ApplianceModelEndianness {
  MsbMsw,
  MsbLsw,
  LsbMsw,
  LsbLsw,
}
